import { VizType } from "@atlas-int/data";
import { ProductLevel } from "@atlas-int/data/types";
import {
  SpecializedVisualizationControlPanel as SpecializedControlPanelBase,
  SettingsButtonContainer,
  ShowTable as ShowTableBase,
} from "@atlas-int/controls";
import LocationDropdown from "../locationDropdown/LocationDropdown";
import { ChevronToggle } from "@atlas-int/ui";
import { DropdownRole } from "../DropdownRole";
import { uiIcons } from "../../../assets/icons";
import { YearInputs } from "../shared/YearInputs";
import { useTutorial } from "../../tutorial/TutorialContext";
import LearnIcon from "../../tutorial/img/learn.svg?react";
import { googleAnalyticsCustomEvent } from "../../../sharedUtilities/analytics";
import ProductClassToggleGroup from "../ProductClassToggleGroup";
import CompactSettingsDropdown from "../settingsPanel/CompactSettingsDropdown";
import { useIsFeasibilityTable } from "../../../routing/typedRoutes";
import { useLocation, useNavigate } from "react-router";

interface SpecializedVisualizationControlPanelProps {
  vizType: VizType.MarketShare | VizType.Feasibility | VizType.ProductSpace;
  isSettingsOpen: boolean;
  toggleSettingsPanel: () => void;
}

const ShowTable = () => {
  const location = useLocation();
  const showTable = useIsFeasibilityTable();
  const navigate = useNavigate();
  const searchParams = new URLSearchParams(location.search);

  return (
    <ShowTableBase
      showTable={showTable}
      onShowGraph={() => navigate(`feasibility?${searchParams.toString()}`)}
      onShowTable={() => {
        searchParams.set("productLevel", `${ProductLevel.Product4digit}`);
        navigate(`feasibility/table?${searchParams.toString()}`);
      }}
    />
  );
};

export const SpecializedVisualizationControlPanel = ({
  vizType,
  isSettingsOpen,
  toggleSettingsPanel,
}: SpecializedVisualizationControlPanelProps) => {
  const { setIsTutorialOpen } = useTutorial();

  const isMarketShare = vizType === VizType.MarketShare;
  const isFeasibility = vizType === VizType.Feasibility;
  const isProductSpace = vizType === VizType.ProductSpace;

  return (
    <SpecializedControlPanelBase
      exporterDropdown={
        <LocationDropdown
          locationSelectionRole={DropdownRole.LocationExporter}
        />
      }
      yearInputs={<YearInputs vizType={vizType} useYearRange={isMarketShare} />}
      showTableToggle={isFeasibility ? <ShowTable /> : undefined}
      productClassToggle={<ProductClassToggleGroup />}
      settingsSection={
        <>
          <SettingsButtonContainer
            data-settings-toggle
            onClick={toggleSettingsPanel}
          >
            <img src={uiIcons.settings} alt="Settings" />{" "}
            Settings
            <ChevronToggle isOpen={isSettingsOpen} />
          </SettingsButtonContainer>
          {isSettingsOpen && (
            <CompactSettingsDropdown onClose={toggleSettingsPanel} />
          )}
        </>
      }
      showTutorial={isProductSpace}
      onTutorialClick={() => {
        googleAnalyticsCustomEvent("btn", "click", "pslearn", "explore");
        setIsTutorialOpen(true);
      }}
      tutorialIcon={<LearnIcon />}
    />
  );
};
